module.exports = __webpack_public_path__ + "static/media/createproject.eddc3f6a.PNG";